import React from 'react'
import _ from 'lodash'

import S from './styled'
import { getColors } from './colors.js'

import Category from './category'

const StepsList = ({
  onAdd,
  onSelect,
  selected,
  onDelete,
  options,
  values,
  appliance,
  onChangeOrder,
  readOnly,
}) => {

  const preparationSteps = _.get(values, `applianceSteps.${appliance.id}.preparationSteps`, [])
  const cookingSteps = _.get(values, `applianceSteps.${appliance.id}.cookingSteps`, [])
  const initialSteps = _.get(values, `applianceSteps.${appliance.id}.initialSteps`, [])
  const finalSteps = _.get(values, `applianceSteps.${appliance.id}.finalSteps`, [])
  const colors = getColors(preparationSteps, cookingSteps, initialSteps, finalSteps)

  return (
    <S.List>

      <Category {...{
        type: 'initial',
        title: 'Initial Steps',
        options,
        steps: initialSteps,
        appliance,
        selected,
        onSelect,
        colors,
        readOnly,
      }}/>

      <Category {...{
        type: 'preparation',
        title: 'Preparation Steps',
        options,
        steps: preparationSteps,
        appliance,
        selected,
        onSelect,
        onAdd,
        onChangeOrder,
        onDelete,
        colors,
        readOnly,
      }}/>

      <Category {...{
        type: 'cooking',
        title: 'Cooking Steps',
        options,
        steps: cookingSteps,
        appliance,
        selected,
        onSelect,
        onAdd,
        onChangeOrder,
        onDelete,
        colors,
        readOnly,
      }}/>

      <Category {...{
        type: 'final',
        title: 'Final Steps',
        options,
        steps: finalSteps,
        appliance,
        selected,
        onSelect,
        colors,
        readOnly,
      }}/>
    </S.List>
  )
}

export default StepsList
